import { useEffect, useState, useRef } from 'react';
import { createOrFetchUser } from '../service';

const BALANCE_POLLING_INTERVAL = 30000; // 30 seconds

const useUserBalance = (isSignedIn, userData) => {
  const [balance, setBalance] = useState(null);
  const intervalRef = useRef(null);

  const fetchBalance = async () => {
    if (!isSignedIn || !userData) return;

    try {
      const { data } = await createOrFetchUser(
        userData.email,
        userData.method,
        userData.shouldSubscribe,
      );
      setBalance(data.balance?.currentBalance);
    } catch (error) {
      console.error('Error fetching user balance:', error);
    }
  };

  useEffect(() => {
    fetchBalance();
    intervalRef.current = setInterval(fetchBalance, BALANCE_POLLING_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isSignedIn, userData]);

  return balance;
};

export default useUserBalance;
